<template>
  <div class="container-list">
    <div class="ml20 f18 blue cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
    <div class="flex">
      <div class="flex1">
        <div class="common-page common-head"></div>
        <div class="common-page common-body">
          <div class="common-page common-list">
            <table class="common-table mt20">
              <thead>
                <tr>
                  <th><span class="mt10">项目名称</span></th>
                  <th><span class="mt10">得分</span></th>
                  <th ><span class="mt10" v-if="involveCaozuo == 2 ? false : true">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr class="safeh">
                  消防安全管理
                </tr>
                <tr v-for="(item, index) in list1" :key="index">
                  <td>
                    <span class="common-add">{{ item.percentage_name }}{{ item.total }}分</span>
                  </td>
                  <td>
                    <!-- oninput="if(value>10) value=10;if(value<0) value=0" -->
                    <input
                      class="common-add1"
                      @input="changeFunc(item, index)"
                      :disabled="item.involve == 0 ? false : true"
                      v-model="item.percentage_score"
                      placeholder="请输入分数"
                    />
                  </td>
                  <td class="buPst" v-if="item.involve == 2?false : true">
                    <a slot="reference">
                      <el-button style="width: 100px" :type="item.involve == 0 ? 'danger' : 'info'" size="mini" @click="ChangeIsFlag1(index)">{{
                        item.involve == 0 ? "无此项" : "取消无此项"
                      }}</el-button>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr class="safeh">
                  建筑防火
                </tr>
                <tr v-for="(item, index) in list2" :key="index">
                  <td>
                    <span class="common-add">{{ item.percentage_name }}{{ item.total }}分</span>
                  </td>
                  <td>
                    <input
                      class="common-add1"
                      @input="changeFunc1(item, index)"
                      :disabled="item.involve == 0 ? false : true"
                      v-model="item.percentage_score"
                      placeholder="请输入分数"
                    />
                  </td>
                  <td class="buPst" v-if="item.involve == 2?false : true">
                    <a slot="reference">
                      <el-button style="width: 100px" :type="item.involve == 0 ? 'danger' : 'info'" size="mini" @click="ChangeIsFlag2(index)">{{
                        item.involve == 0 ? "无此项" : "取消无此项"
                      }}</el-button>
                    </a>
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr class="safeh">
                  消防设施
                </tr>
                <tr v-for="(item, index) in list3" :key="index">
                  <td>
                    <span class="common-add">{{ item.percentage_name }}{{ item.total }}分 </span>
                  </td>
                  <td>
                    <input
                      class="common-add1"
                      @input="changeFunc2(item, index)"
                      :disabled="item.involve == 0 ? false : true"
                      v-model="item.percentage_score"
                      placeholder="请输入分数"
                    />
                  </td>
                  <td class="buPst" v-if="item.involve == 2?false : true">
                    <a slot="reference">
                      <el-button style="width: 100px" :type="item.involve == 0 ? 'danger' : 'info'" size="mini" @click="ChangeIsFlag3(index)">{{
                        item.involve == 0 ? "无此项" : "取消无此项"
                      }}</el-button>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="btn-box center">
            <div class="l-btn" @click="onSubmit" v-hasPermi="['score:maintenanceAllDetails:insert']">保存</div>
            <div class="l-btn ml20" @click="$router.back(-1)">返回</div>
          </div>
        </div>
        <!-- <el-dialog
          title="查询"
          :visible.sync="showDia"
          :close-on-click-modal="false"
        >
          <fm-generate-form
            :data="searchForm"
            :remote="remoteFuncs"
            :value="editData"
            ref="searchForm"
          ></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small"
              >确定</el-button
            >
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      // cpNum: "",
      uuid: this.$route.query.id,
      showDia: false,
      searchForm: this.$getForm("weibaoProSearch"),
      remoteFuncs: {},
      params: {
        key: "",
        percentage_name: "",
        page: 1,
        starttime: "",
        endtime: "",
      },
      params1: {
        key: "",
      },
      list: [],
      list1: [], //消防安全管理
      list2: [], //建筑防火
      list3: [], //消防设施
      arr1: [],
      arr2: [],
      arr3: [],
      count: 0,
      editData: {},
      keys: "",
      involveCaozuo:null
    };
  },
  created() {
    this.params.key = this.uuid;
    this.keys = this.uuid;
    // console.log(this.keys);
    // this.keys=this.uuid
    // this.getList();
    // setTimeout(() => {
    // //   console.log(this.list);
    // }, 6000);
  },
  mounted() {
    this.$post("/score/maintenanceAssessDetails", { key: this.keys }).then((res) => {
      // console.log(res.data);
      this.list = res.data;
      this.involveCaozuo=this.list[0].involve
      console.log(this.involveCaozuo,this.list,'involveCaozuo');
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].type == 1) {
          this.list1.push(this.list[i]);
          this.arr1 = JSON.parse(JSON.stringify(this.list1));
        } else if (this.list[i].type == 2) {
          this.list2.push(this.list[i]);
          this.arr2 = JSON.parse(JSON.stringify(this.list2));
        } else if (this.list[i].type == 3) {
          this.list3.push(this.list[i]);
          this.arr3 = JSON.parse(JSON.stringify(this.list3));
        }
      }
      // console.log(this.list[0].involve,'list');
      //   if (!this.$store.state.compList.length) {
      //     this.$store.commit("SAVECOMP", res.data);
      //     // console.log(res.data);
      //   }
    });
  },
  //   watch: {
  //       list1:{
  //           handler(newName,oldName){
  //               console.log(newName);
  //           },
  //           immediate:true,
  //           deep:true
  //       }
  //     // uuid(){
  //     //     this.params.uuid = this.uuid
  //     //     this.getList()
  //     // }
  //   },
  methods: {
    changeFunc(item, index) {
      if (item.percentage_score > item.total) {
        this.$message({
          message: "请不要超出规定的最大分数",
          type: "warning",
        });
        item.percentage_score = this.arr1[index].percentage_score;
      }
      if (item.percentage_score < 0) {
        this.$message({
          message: "请不要小于规定的最小分数",
          type: "warning",
        });
        item.percentage_score = 0;
      }
    },
    changeFunc1(item, index) {
      if (item.percentage_score > item.total) {
        this.$message({
          message: "请不要超出规定的最大分数",
          type: "warning",
        });
        item.percentage_score = this.arr2[index].percentage_score;
      }
      if (item.percentage_score < 0) {
        this.$message({
          message: "请不要小于规定的最小分数",
          type: "warning",
        });
        item.percentage_score = 0;
      }
    },
    changeFunc2(item, index) {
      if (item.percentage_score > item.total) {
        this.$message({
          message: "请不要超出规定的最大分数",
          type: "warning",
        });
        item.percentage_score = this.arr3[index].percentage_score;
      }
      if (item.percentage_score < 0) {
        this.$message({
          message: "请不要小于规定的最小分数",
          type: "warning",
        });
        item.percentage_score = 0;
      }
    },
    ChangeIsFlag1(index) {
      if (this.list1[index].involve == 1) {
        this.list1[index].involve = 0;
      } else {
        this.list1[index].involve = 1; //取消无此项
      }
    },
    ChangeIsFlag2(index) {
      if (this.list2[index].involve == 1) {
        this.list2[index].involve = 0;
      } else {
        this.list2[index].involve = 1; //取消无此项
      }
    },
    ChangeIsFlag3(index) {
      if (this.list3[index].involve == 1) {
        this.list3[index].involve = 0;
      } else {
        this.list3[index].involve = 1; //取消无此项
      }
    },
    onSubmit() {
      this.list = [];
      let date = this.list.concat(this.list1, this.list2, this.list3);
      console.log(date);
      for (let j = 0; j < date.length; j++) {
        String((date[j].percentage_lose = Number(date[j].total) - Number(date[j].percentage_score)));
      }

      //   console.log(date);
      this.$post("/score/maintenanceAssessDetailsUpdate", date).then((res) => {
        // console.log(res);
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
    },
    // getList() {
    //   this.$post("/score/maintenancelists", this.params).then((res) => {
    //     this.list = res.data.list;
    //   });
    // },
    // save(it) {
    //   let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
    //   let api = it.uuid ? "/score/scoreupdate" : "score/scoreinsert";
    //   this.$post(api, it)
    //     .then((res) => {
    //       this.$message.success("保存成功");
    //       loading.close();
    //     })
    //     .catch((err) => {
    //       loading.close();
    //     });
    // },
    // changeStatus(uuid) {
    //   //   this.$post(`/score/scoredelete/${uuid}`)
    //   //     .then((res) => {
    //   //       this.$message.success("删除成功");
    //   //       this.getList();
    //   //     })
    //   //     .catch((e) => {});
    // },

    // searchSubmit() {
    //   this.$refs.searchForm
    //     .getData()
    //     .then((data) => {
    //       //log(data)
    //       this.params = { ...this.params, ...data };
    //       console.log(this.params);
    //       this.params.page = 1;

    //       this.getList();
    //       this.showDia = false;
    //     })
    //     .catch((e) => {});
    // },
  },
};
</script>
<style lang="scss">
.common-table > tbody > tr > td {
  color: #000;
}
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
.noPoint {
  width: 100px;
  background-color: #f3b7be;
  color: #fb6a7b;
}
.safeh {
  display: inline-block;
  font-weight: 600;
  font-size: 16px;
  margin-top: 10px;
}
.common-add {
  font-size: 16px;
}
.common-add1 {
  width: 100px;
  text-align: center;
  font-size: 16px;
}
.mt10 {
  font-weight: 600;
  font-size: 20px;
}
.buPst {
  padding: 3px;
}
</style>
